export default __webpack_public_path__ + "static/media/ProHello.94b71e00.gif";